import type { CurrencyCode, LocaleOfStoreType } from "@beautypie/core";
import {
  currencyToLocale,
  localeToCurrency,
  standardCurrencyFormat
} from "@beautypie/core";

/**
 * @param value monetary value in subunit (cents or pence)
 * @param locale
 * @param currencyCode
 */
export function formatCurrency(
  value: number,
  locale: LocaleOfStoreType,
  currencyCode: CurrencyCode,
  removeZeroDecimals = false
): string {
  if (!Number.isInteger(value)) {
    throw new Error("Expecting a value in subunits");
  }

  const currency = currencyCode || localeToCurrency[locale];
  const formattingLocale = currencyToLocale[currency];

  const res = standardCurrencyFormat(
    { value, unit: "subunit" },
    {
      currency: currencyCode,
      locale: formattingLocale,
      decimals: removeZeroDecimals ? "auto" : "all"
    }
  );

  return res.formatted;
}
